import React from 'react'
import {Link} from 'react-router-dom'
import {bindActionCreators} from 'redux'
import {push} from 'react-router-redux'
import {connect} from 'react-redux'

import config from '../../config.js'

import 'Skelet/src/start.css'; // importing this seems to make it get stuck, so even on other routes and containers the css is still there.

import {toggleDropdown, openModal, closeModal} from 'Skelet/src/modules/functions.js'
import ModalAccount from 'Skelet/src/components/ModalAccount.js';
import StartFooter from 'Skelet/src/components/Start_Footer.js';
import CompanyFooter from 'Skelet/src/components/Company_Footer.js';
import logo from '../../images/polymedia-citrus.png';

import i18n_texts from '../../i18n.js';


class StartRoute extends React.Component {

  constructor(props) {
    super(props);
    let modal_open = false;
    let modal_content = "login";
    let reset_token = null;
    if(typeof URLSearchParams === "function") {
      let params = new URLSearchParams(this.props.location.search);
      let param_login = params.get('login');
      let param_register = params.get('register');
      let param_reset = params.get('reset');
      let param_verify = params.get('verify'); // this won't be from an e-mail, but might be helpful to manually trigger when bugged.
      if(param_login === "") {
        modal_open = true;
      } else if(param_register === "") {
        modal_open = true;
        modal_content = "register";
      } else if(param_reset !== null) {
        modal_open = true;
        modal_content = "reset";
        reset_token = params.get('token');
      } else if(param_verify !== null) {
        modal_open = true;
        modal_content = "verify";
      }
    }
    if(this.props.lang === "NL") {
      document.documentElement.setAttribute('lang', "nl");
    } else {
      document.documentElement.setAttribute('lang', "en");
    }

    this.state = {modal_open:modal_open, modal_content:modal_content, reset_token:reset_token, is_scrolling:false, dropdown_open:false};
    this.handleScroll = this.handleScroll.bind(this);
  }

  componentDidMount() {
    document.addEventListener('scroll', this.handleScroll);
  }

  componentWillUnmount() {
    document.removeEventListener('scroll', this.handleScroll);
  }

  handleScroll(e) {
    if(window.pageYOffset === 0) {
      this.setState({is_scrolling:false});
    } else if(!this.state.is_scrolling) {
      this.setState({is_scrolling:true});
    }
  }

  render() {
    let link_start = "/start";
    let link_blog = "/blog";
    let link_roadmap = "/roadmap";
    let link_pricing = "/prijzen";
    let linktext_pricing = "Prijzen";
    let linktext_login = "Inloggen";
    let linktext_register = "Start nu GRATIS";
    if(this.props.lang === "EN") {
      link_start = "/en/start";
      link_blog = "/en/blog";
      link_roadmap = "/en/roadmap";
      link_pricing = "/en/pricing";
      linktext_pricing = "Pricing";
      linktext_login = "Login";
      linktext_register = "Join for FREE";
    }
    const Header = () => <header className={(this.state.is_scrolling) ? "scrolling" : null}><div className="container wrap wrap-full">{/* @TODO: los component */}
      <div className="primary">
        <Link to={link_start} onClick={() => document.getElementById("main").scrollIntoView(true)} className="logo"><img src={logo} alt="Citrus by Polymedia" style={{height:"auto"}} /></Link>
      </div>
      <div className="secondary">
            <nav className="navigation">
              <ol>
                {this.props.lang === "EN" && <li className="md-shown nav-item"><a href="/start" className="btn btn-offset btn-fat">Nederlands</a></li>}
                <li className={"md-shown nav-item" + ((this.props.pathname === link_start) ? " current" : "")}><a href={link_start} className="btn btn-offset btn-fat">Start</a></li>
                <li className={"md-shown nav-item" + ((this.props.pathname === link_blog) ? " current" : "")}><a href={link_blog} className="btn btn-offset btn-fat">Blog</a></li>
                <li className={"md-shown nav-item" + ((this.props.pathname === link_roadmap) ? " current" : "")}><a href={link_roadmap} className="btn btn-offset btn-fat">Roadmap</a></li>
                <li className={"md-shown nav-item" + ((this.props.pathname === link_pricing) ? " current" : "")}><a href={link_pricing} className="btn btn-offset btn-fat">{linktext_pricing}</a></li>
                {!this.props.session_token && <li className="md-shown nav-item"><button onClick={() => openModal(this)} className="btn btn-offset btn-fat">{linktext_login}</button></li>}
                {!this.props.session_token && <li className="md-shown nav-item"><button onClick={() => openModal(this, null, "register")} className="btn btn-e btn-fat">{linktext_register}</button></li>}
                {this.props.session_token && <li className="md-shown nav-item"><button onClick={() => {document.getElementById("main").scrollIntoView(true);this.props.push("/")}} className="btn btn-d btn-fat">Dashboard</button></li>}
                <li className={"md-hidden nav-item dropdown" + ((this.state.dropdown_open) ? " open" : "")} ref={this.setWrapperRef}>
                  <button onClick={() => toggleDropdown(this)} className="btn btn-d btn-fat">menu</button>
                  <div className="dropdown-menu">
                    <div className="dropdown-caret">
                      <span className="caret-outer"></span>
                      <span className="caret-inner"></span>
                    </div>
                    <ul style={{textAlign:"center"}}>
                      {this.props.lang === "EN" && <li className="nav-item"><button onClick={() => {toggleDropdown(this);document.getElementById("main").scrollIntoView(true);this.props.push("/start")}} className="btn btn-offset btn-fat">Nederlands</button></li>}
                      <li className={"nav-item" + ((this.props.pathname === link_start) ? " current" : "")}><button onClick={() => {toggleDropdown(this);document.getElementById("main").scrollIntoView(true);this.props.push(link_start)}} className="btn btn-offset btn-fat">Start</button></li>
                      <li className={"nav-item" + ((this.props.pathname === link_blog) ? " current" : "")}><button onClick={() => {toggleDropdown(this);document.getElementById("main").scrollIntoView(true);this.props.push(link_blog)}} className="btn btn-offset btn-fat">Blog</button></li>
                      <li className={"nav-item" + ((this.props.pathname === link_roadmap) ? " current" : "")}><button onClick={() => {toggleDropdown(this);document.getElementById("main").scrollIntoView(true);this.props.push(link_roadmap)}} className="btn btn-offset btn-fat">Roadmap</button></li>
                      <li className={"nav-item" + ((this.props.pathname === link_pricing) ? " current" : "")}><button onClick={() => {toggleDropdown(this);document.getElementById("main").scrollIntoView(true);this.props.push(link_pricing)}} className="btn btn-offset btn-fat">{linktext_pricing}</button></li>
                      {!this.props.session_token && <li className="nav-item"><button onClick={() => {toggleDropdown(this);openModal(this)}} className="btn btn-offset btn-fat">{linktext_login}</button></li>}
                      {!this.props.session_token && <li className="nav-item"><button onClick={() => {toggleDropdown(this);openModal(this, null, "register")}} className="btn btn-e btn-fat">{linktext_register}</button></li>}
                      {this.props.session_token && <li className="md-shown nav-item"><button onClick={() => {document.getElementById("main").scrollIntoView(true);this.props.push("/")}} className="btn btn-d btn-fat">Dashboard</button></li>}
                    </ul>
                  </div>
                </li>
              </ol>
            </nav>
          </div>
    </div></header>;

    let sitemap = {"Start":link_start, "Blog":link_blog, "Roadmap":link_roadmap, "Oplossingen":"/oplossingen", [linktext_pricing]:link_pricing};
    if(this.props.lang === "EN") {
      sitemap = {"Start":link_start, "Blog":link_blog, "Roadmap":link_roadmap, [linktext_pricing]:link_pricing};
    }

    return (
      <div>
        <div className="start">
        <ModalAccount shouldShow={this.state.modal_open} close={() => closeModal(this)} modal_content={this.state.modal_content} reset_token={this.state.reset_token} config={config} header={config.app_id} headerimg={logo} ribbon app_language={this.props.lang} />
          <main>
          <Header />
            {/*<Route {...this.props} abc="def" />
            this doesn't pass the props, except for the [this.props], which are passed down from app.js
            cloneElement crashes because of an undefined error, even though it does work with CREATEelement.. */}
            {React.createElement(this.props.component, {
              openModal: (modal_content) => openModal(this, null, modal_content),
              app_language: this.props.lang,
              i18n_texts
            })}
            {/*this.props.children && React.cloneElement(this.props.children, {
              openModal: this.openModal
            })*/}
          </main>
          {/*<CompanyFooter site="Citrus" sitemap={{"Start":"start", "Features":"features", "Solutions":"solutions", "Website Polls":"website-polls", "Blog":"blog", "Roadmap":"roadmap", "Pricing":"pricing"}} />*/}
          <CompanyFooter lang={this.props.lang} site="Citrus" sitemap={sitemap} linkedin="https://www.linkedin.com/company/citrus-by-polymedia/" />
          <StartFooter lang={this.props.lang} />
          <div onClick={() => this.toggle()} className="clickable-text" style={{cursor:"pointer", background:"#ff9934", color:"#fff", padding:"6px 10px 7px", display:"inline-block", rotate:"270deg", position:"fixed", bottom:"140px", right:"-23px", borderTopRightRadius:"7px", borderTopLeftRadius:"7px"}}>feedback</div>
          <div style={this.state.shown ? null : {display:"none"}}><iframe title="Citrus Feedback" src="https://citrus.polymedia.nl/feedback/b8S03gEUecvp23Jd3AmHJyFAZl7gwrkk?embed" height="900" style={{border:"0", width:"450px", maxWidth:"calc(100% - 55px)", position:"fixed", bottom:"30px", right:"45px", height:"400px", maxHeight:"60%"}} /></div>
        </div>
      </div>
    );
  }


  toggle = () => {
    this.setState({shown:!this.state.shown});
  };

}


function mapStateToProps(state, ownProps) {
  let session_token = null;
  if(state.apiData["login"] !== undefined && (state.apiData["login"]["data"]["token"] !== undefined || state.apiData["login"]["data"]["token"] === null)) {
    session_token = state.apiData["login"]["data"]["token"];
  }
  return {
    session_token: session_token,
    pathname: ownProps.location.pathname
  }
}

function mapDispatchToProps(dispatch){
  return bindActionCreators({
    push,
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(StartRoute)



// WEBPACK FOOTER //
// ./src/containers/route-containers/StartRoute.js